import React from "react";
import PropTypes from "prop-types";

const columns = [
    "පොරොන්දම",
    "ස්ත්‍රී",
    "පුරුෂ",
    "ශුභ/අශුභ",
    "අ.කූ"
];


const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12px',
    background: '#fff',
    marginTop: '24px',
};

const thTdStyle = {
    border: '1px solid #ccc',
    padding: '0px 2px',
    textAlign: 'center',
};


const tdTdStyle = {
    border: '1px solid #ccc',
    padding: '0px 2px',
    textAlign: 'left',
};

function MatchDataTable({ records }) {
    return (
        <table style={tableStyle}>
            <thead>
                <tr>
                    {columns.map(col => (
                        <th key={col} style={thTdStyle}>{col}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {records.map((row, idx) => (
                    <tr key={idx}>
                            <td style={tdTdStyle}>
                                {row.pv}
                            </td>
                            <td style={tdTdStyle}>
                                {row.fv}
                            </td>
                            <td style={tdTdStyle}>
                                {row.mv}
                            </td>
                            <td style={tdTdStyle}>
                                {row.s ? "ශුභ" : "අශුභ"}
                            </td>
                            <td style={tdTdStyle}>
                                {row.ak}
                            </td>
                           
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default function MatchDataTables({ matchDataRecords }) {
    console.log("MatchDataTables records:", matchDataRecords);

    const leftRecords = matchDataRecords.p10;
    const rightRecords = matchDataRecords.p20;

    return (
        <div style={{ display: "flex", gap: 24 }}>
            <div style={{ flex: 1 }}>
                <MatchDataTable records={leftRecords} />
            </div>
            <div style={{ flex: 1 }}>
                <MatchDataTable records={rightRecords} />
            </div>
        </div>
    );
}

MatchDataTables.propTypes = {
    matchDataRecords: PropTypes.arrayOf(PropTypes.object).isRequired,
};

MatchDataTable.propTypes = {
    records: PropTypes.arrayOf(PropTypes.object).isRequired,
};